module.exports = __webpack_public_path__ + "static/media/edit.18e68a52.svg";